import type React from 'react';

import styles from '@components/tags-component/styles/verktoyTagsComponent.module.scss';
import { useGetResources } from '@hooks/useGetResources';
import { Innholdstype } from '@src/types/minhelseentities';

import Icon from '@helsenorge/designsystem-react/components/Icon';
import EChat from '@helsenorge/designsystem-react/components/Icons/EChat';
import Form from '@helsenorge/designsystem-react/components/Icons/Form';
import Graph from '@helsenorge/designsystem-react/components/Icons/Graph';
import InfoSignStroke from '@helsenorge/designsystem-react/components/Icons/InfoSignStroke';
import Notepad from '@helsenorge/designsystem-react/components/Icons/Notepad';
import Podcast from '@helsenorge/designsystem-react/components/Icons/Podcast';
import Puzzle from '@helsenorge/designsystem-react/components/Icons/Puzzle';
import SpeechBubble from '@helsenorge/designsystem-react/components/Icons/SpeechBubble';
import Toolbox from '@helsenorge/designsystem-react/components/Icons/Toolbox';
import VideoCamera from '@helsenorge/designsystem-react/components/Icons/VideoCamera';
import Website from '@helsenorge/designsystem-react/components/Icons/Website';

import TagComponent from './tag-component';

interface Props {
  innholdstype: Innholdstype;
}

const InnholdstypeTag = ({ innholdstype }: Props): React.JSX.Element | null => {
  const resources = useGetResources();
  let tagValue: string | undefined = '';

  let tagIcon: typeof Toolbox = Toolbox;

  switch (innholdstype) {
    case Innholdstype.Informasjon:
      tagValue = resources?.verktoyInnholdstype_Informasjon;
      tagIcon = InfoSignStroke;
      break;
    case Innholdstype.Video:
      tagValue = resources?.verktoyInnholdstype_Video;
      tagIcon = VideoCamera;
      break;
    case Innholdstype.Podkast:
      tagValue = resources?.verktoyInnholdstype_Podkast;
      tagIcon = Podcast;
      break;
    case Innholdstype.Oppgaver:
      tagValue = resources?.verktoyInnholdstype_Oppgaver;
      tagIcon = Form;
      break;
    case Innholdstype.Spill:
      tagValue = resources?.verktoyInnholdstype_Spill;
      tagIcon = Puzzle;
      break;
    case Innholdstype.Chat:
      tagValue = resources?.verktoyInnholdstype_Chat;
      tagIcon = EChat;
      break;
    case Innholdstype.Forum:
      tagValue = resources?.verktoyInnholdstype_Forum;
      tagIcon = Website;
      break;
    case Innholdstype.Egenregistreringer:
      tagValue = resources?.verktoyInnholdstype_Egenregistreringer;
      tagIcon = Notepad;
      break;
    case Innholdstype.Maaleverktoy:
      tagValue = resources?.verktoyInnholdstype_Maaleverktoy;
      tagIcon = Graph;
      break;
    case Innholdstype.AnbefalningerOgRaad:
      tagValue = resources?.verktoyInnholdstype_AnbefalningerOgRaad;
      tagIcon = SpeechBubble;
      break;
    default:
      break;
  }

  return (
    <div className={styles.innholdContainer}>
      <Icon className={styles.tagIcon} svgIcon={tagIcon} size={32} />
      <TagComponent tagValue={tagValue} isPlainText={true} />
    </div>
  );
};

export default InnholdstypeTag;
